import { Abacus } from "core/Abacus.Core";
import { Class } from "core/Abacus.Utilities";
import autocomplete from "autocomplete.js";

let AutocompleteClassOptions = {
	AutocompleteOptions: {
        autoselect: false,
        autoselectOnBlur: true,
        minLength: 2,
        debounce: 200,
        autoWidth: true,
        hint: false
	}
}

class Autocomplete extends Class {
	constructor(autocomplete, options) {
    super();
    this.element = autocomplete;
    this.setOptions(AutocompleteClassOptions, options);
    this.setupAutocomplete();
	}

	setupAutocomplete(){
    var self = this;
    var _elem=$(self.element);
    _elem.addClass('autocomplete-applied');
    self.options.AutocompleteOptions.minLength = (_elem.attr('data-minlength')? parseInt(_elem.attr('data-minlength'),10) : self.options.AutocompleteOptions.minLength);
    self.options.AutocompleteOptions.autoselect = (_elem.attr('data-autoselect')? _elem.attr('data-autoselect') === 'true' : self.options.AutocompleteOptions.autoselect);
    self.options.AutocompleteOptions.hint = (_elem.attr('data-autoselect')? _elem.attr('data-autoselect') === 'true' : self.options.AutocompleteOptions.hint);
    self.options.AutocompleteOptions.autoselectOnBlur = (_elem.attr('data-autoselectonblur')? _elem.attr('data-autoselectonblur') === 'true' : self.options.AutocompleteOptions.autoselectOnBlur);
    var autocompleteProxy=autocomplete(self.element,self.options.AutocompleteOptions,[{source:function(query,callback){
      _elem.addClass('loading');
      $.ajax({
        method: 'GET',
        url: '/searchsuggest?search='+encodeURI(query),
        dataType: 'json',
        context: self.element
      })
      .done(function(data, textStatus, jqXHR) {
        var context = this;
        if(data&&data.suggestions&&data.suggestions[0]&&data.suggestions[0].terms&&data.suggestions[0].terms.length){
          var terms = data.suggestions[0].terms.map(function(str) {
            return {"term":str,"value":str};
          });
          $(this).removeClass('loading');
          callback(terms);
        }else{
          $(this).removeClass('loading');
          callback([]);
        }
      })
      .fail(function(jqXHR, textStatus, errorThrown) {
        console&&console.log('Could not call taxonomy service: ',jqXHR);
        $(this).removeClass('loading');
        callback([]);
      });
    },displayKey:'term',templates: {
      suggestion: function() {
        var suggestion = (suggestion || arguments[0] || {"term":"-","value":""});
        var returnVal = (suggestion&&suggestion.term||' - ');
        var query = $('.autocomplete.aa-input:focus').val().trim().replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g, '\\$&');
        return returnVal = returnVal.replace(new RegExp('(' + query + ')', 'ig'), function ($1, match) {
          return '<em class="match">' + match + '</em>';
        });
      }
    }}]);
	}
}

export { Autocomplete };


// WEBPACK FOOTER //
// ./Javascript/core/classes/autocomplete.class.js